function getSearchMode(): string {
	const urlParams = new URLSearchParams( window.location.search );
	const mode = urlParams.get( 'searchmode' );
	return ( mode === 'simple' || mode === 'detailed' ) ? mode : 'simple';
}

function toggleSearchMode( searchMode: string, updateURL = true ) {
	const searchModeInput = document.querySelector( 'input[name="searchmode"]' ) as HTMLInputElement;
	const simpleButton = document.getElementById( 'search-type-simple' );
	const detailedButton = document.getElementById( 'search-type-detailed' );
	const simpleResults = document.getElementById( 'search-results-simple' );
	const detailedResults = document.getElementById( 'search-results-detailed' );
	const privacyBox = document.getElementById( 'search-type-detailed-privacy' );

	if ( !searchModeInput || !simpleButton || !detailedButton || !simpleResults || !detailedResults || !privacyBox ) {
		return;
	}

	const consentGiven = getConsentCookie();

	if ( searchMode === 'simple' ) {
		searchModeInput.value = 'simple';
		simpleButton.setAttribute( 'aria-selected', 'true' );
		detailedButton.setAttribute( 'aria-selected', 'false' );
		simpleResults.setAttribute( 'aria-hidden', 'false' );
		detailedResults.setAttribute( 'aria-hidden', 'true' );
		privacyBox.setAttribute( 'aria-hidden', 'true' );
	} else if ( searchMode === 'detailed' ) {
		searchModeInput.value = 'detailed';
		simpleButton.setAttribute( 'aria-selected', 'false' );
		detailedButton.setAttribute( 'aria-selected', 'true' );
		simpleResults.setAttribute( 'aria-hidden', 'true' );
		detailedResults.setAttribute( 'aria-hidden', 'false' );
		privacyBox.setAttribute( 'aria-hidden', consentGiven ? 'true' : 'false' );
	}

	if ( updateURL ) {
		const newUrl = new URL( window.location.href );
		newUrl.searchParams.set( 'searchmode', searchMode );
		history.pushState( {}, '', newUrl.toString() );
	}
}

const CUSTOM_CSS = `
	.gsc-control-cse {
    	padding-top: 2em !important;
	}
	.gsc-control-cse .gsc-result-info-container .gsc-result-info {
    	color: #ffffff !important;
	}
	.gsc-control-cse .gsc-orderby-container .gsc-orderby-label {
    	color: #ffffff !important;
	}
	.gsc-control-cse .gsc-option-menu-container {
    	width: 120px !important;
	}
	.gsc-control-cse .gsc-results .gsc-cursor-box .gsc-cursor-page {
    	background-color: transparent !important;
		color: #ffffff !important;
	}
`;

function loadGoogleSiteSearchScript() {
	const style = document.createElement( 'style' );
	style.textContent = CUSTOM_CSS;
	document.head.appendChild( style );
	const script = document.createElement( 'script' );
	//script.src = 'https://cse.google.com/cse.js?cx=92f9d596cda894226';
	script.src = 'https://cse.google.com/cse.js?cx=016902930768102511357:u9gm7uncsin'; // oldest one
	script.async = true;
	document.body.appendChild( script );
}

function setConsentCookie() {
	document.cookie = "consent=true; path=/; max-age=" + 60 * 60 * 24 * 365; // 1 year
}

function getConsentCookie(): boolean {
	return document.cookie.split( '; ' ).includes( 'consent=true' );
}

function hidePrivacyBox() {
	const privacyBox = document.getElementById( 'search-type-detailed-privacy' );
	if ( privacyBox ) {
		privacyBox.setAttribute( 'aria-hidden', 'true' );
	}
}

function setupEventListeners() {
	const simpleButton = document.getElementById( 'search-type-simple' );
	const detailedButton = document.getElementById( 'search-type-detailed' );
	const onceButton = document.getElementById( 'search-privacy-once' );
	const alwaysButton = document.getElementById( 'search-privacy-always' );

	if ( simpleButton ) {
		simpleButton.addEventListener( 'click', () => toggleSearchMode( 'simple' ) );
	}
	if ( detailedButton ) {
		detailedButton.addEventListener( 'click', () => toggleSearchMode( 'detailed' ) );
	}
	if ( onceButton ) {
		onceButton.addEventListener( 'click', () => {
			loadGoogleSiteSearchScript();
			hidePrivacyBox();
		} );
	}
	if ( alwaysButton ) {
		alwaysButton.addEventListener( 'click', () => {
			loadGoogleSiteSearchScript();
			setConsentCookie();
			hidePrivacyBox();
		} );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	const searchMode = getSearchMode();
	setupEventListeners();
	if ( getConsentCookie() ) {
		loadGoogleSiteSearchScript();
	}
	toggleSearchMode( searchMode, false ); // Initialize without updating the URL
} );
